import { render, staticRenderFns } from "./LanguageCard.vue?vue&type=template&id=ebdce224&scoped=true&lang=html"
import script from "./LanguageCard.vue?vue&type=script&lang=ts"
export * from "./LanguageCard.vue?vue&type=script&lang=ts"
import style0 from "./LanguageCard.vue?vue&type=style&index=0&id=ebdce224&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdce224",
  null
  
)

export default component.exports